import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { languageType, ResponsiveType } from "../../interface/redux/config";
import { RootState } from "../../reducers";
import { LanguageChange } from "../../reducers/config";
import DeskHeader from "./Responsive/DeskHeader";
import TabletMobileHeader from "./Responsive/TabletMobileHeader";

const Header = ({ Mobile, Tablet }: ResponsiveType) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const language = useSelector<RootState, languageType>(
    (state) => state.config.language
  );
  const [isHover, setIsHover] = useState<boolean>(false);

  const isHeaderDesktop = useMediaQuery({ minWidth: 900 });

  const ChangeLanguage = useCallback(() => {
    dispatch(LanguageChange(language === "kr" ? "eng" : "kr"));
  }, [language, dispatch]);

  useEffect(() => {
    document.getElementById("root")?.scrollTo(0, 0);
    setIsHover(false);
    return () => {};
  }, [pathname]);

  const isKr = language === "kr";
  const openNav = isKr ? Open_Nav_layout_kr : Open_Nav_layout_en;
  const mbNav = isKr ? MB_Nav_layout_kr : MB_Nav_layout_en;

  return (
    <>
      {isHeaderDesktop ? (
        <DeskHeader
          Nav_layout={Nav_layout}
          Open_Nav_layout={openNav}
          navigate={navigate}
          setIsHover={setIsHover}
          isHover={isHover}
          language={language}
          ChangeLanguage={ChangeLanguage}
          pathname={pathname}
        />
      ) : (
        <TabletMobileHeader
          Mobile={Mobile}
          Tablet={Tablet}
          Open_Nav_layout={mbNav}
          setIsHover={setIsHover}
          isHover={isHover}
          language={language}
          ChangeLanguage={ChangeLanguage}
          pathname={pathname}
        />
      )}
    </>
  );
};

export default Header;

const Nav_layout = ["ABOUT", "R&D", "BUSINESS", "CULTURE", "CONTACT US"];

const Open_Nav_layout_kr = [
  { title: "ABOUT", list: [
    { title: "회사소개", link: "/about/intro" },
    { title: "기업연혁", link: "/about/history" },
    { title: "CI 소개", link: "/about/ci" },
  ]},
  { title: "R&D", list: [
    { title: "자동차 전장", link: "/rnd/car" },
    { title: "에너지 개발", link: "/rnd/energy" },
  ]},
  { title: "BUSINESS", list: [
    { title: "SMART SOLUTION", link: "/business/smart" },
    { title: "TOPST", link: "/business/topst" },
  ]},
  { title: "CULTURE", list: [
    { title: "채용공고", link: "/culture/job" },
  ]},
];

const Open_Nav_layout_en = [
  { title: "ABOUT", list: [
    { title: "Company", link: "/about/intro" },
    { title: "History", link: "/about/history" },
    { title: "CI", link: "/about/ci" },
  ]},
  { title: "R&D", list: [
    { title: "Automotive", link: "/rnd/car" },
    { title: "Energy", link: "/rnd/energy" },
  ]},
  { title: "BUSINESS", list: [
    { title: "SMART SOLUTION", link: "/business/smart" },
    { title: "TOPST", link: "/business/topst" },
  ]},
  { title: "CULTURE", list: [
    { title: "Careers", link: "/culture/job" },
  ]},
];

const MB_Nav_layout_kr = [
  { title: "ABOUT", type: "/about", list: [
    { title: "회사소개", link: "/about/intro" },
    { title: "기업연혁", link: "/about/history" },
    { title: "CI 소개", link: "/about/ci" },
  ]},
  { title: "R&D", type: "/rnd", list: [
    { title: "자동차 전장", link: "/rnd/car" },
    { title: "에너지 개발", link: "/rnd/energy" },
  ]},
  { title: "BUSINESS", type: "/business", list: [
    { title: "SMART SOLUTION", link: "/business/smart" },
    { title: "TOPST", link: "/business/topst" },
  ]},
  { title: "CULTURE", type: "/culture", list: [
    { title: "채용공고", link: "/culture/job" },
  ]},
  { title: "CONTACT US", type: "/contact", list: [] },
];

const MB_Nav_layout_en = [
  { title: "ABOUT", type: "/about", list: [
    { title: "Company", link: "/about/intro" },
    { title: "History", link: "/about/history" },
    { title: "CI", link: "/about/ci" },
  ]},
  { title: "R&D", type: "/rnd", list: [
    { title: "Automotive", link: "/rnd/car" },
    { title: "Energy", link: "/rnd/energy" },
  ]},
  { title: "BUSINESS", type: "/business", list: [
    { title: "SMART SOLUTION", link: "/business/smart" },
    { title: "TOPST", link: "/business/topst" },
  ]},
  { title: "CULTURE", type: "/culture", list: [
    { title: "Careers", link: "/culture/job" },
  ]},
  { title: "CONTACT US", type: "/contact", list: [] },
];
